// src/config/tenant.js
//
// ─────────────────────────────────────────────────────────────────────────────
// MULTI-TENANT SYSTEM
// ─────────────────────────────────────────────────────────────────────────────
// Each client gets their own config here. The app reads the current tenant
// from the REACT_APP_TENANT_ID environment variable set at build/deploy time.
//
// For hosting multiple clients:
//   - Vercel: set REACT_APP_TENANT_ID in project env vars per deployment
//   - Netlify: same — set it per site
//   - Each client = separate deployment, same codebase, different env vars
//
// TENANT IDs available: "bookyara-demo" | "marcus-barbershop" | "diego-studio"
// ─────────────────────────────────────────────────────────────────────────────

const TENANTS = {
  "bookyara-demo": {
    id:       "bookyara-demo",
    name:     "Bookyara",
    tagline:  "Premium Grooming Studio",
    timezone: "America/New_York",
    address:  "124 Barber Lane, Downtown District",
    phone:    "+1 (555) 012-3456",
    email:    "hello@bookyara.com",
    hours:    "Mon–Sat 9 AM – 7 PM  •  Sun 10 AM – 5 PM",
    rating:   4.9,
    reviews:  512,
    services: [
      { id: "s1", name: "Classic Haircut",      description: "Precision cut tailored to your style",           duration: 30, price: 25, icon: "✂️", popular: false },
      { id: "s2", name: "Beard Trim & Shape",   description: "Clean lines, sharp edges, perfect shape",        duration: 20, price: 15, icon: "🪒", popular: false },
      { id: "s3", name: "Hair + Beard Combo",   description: "Full grooming experience — the works",           duration: 50, price: 38, icon: "💈", popular: true  },
      { id: "s4", name: "Hot Towel Shave",      description: "Traditional straight-razor shave with hot towel",duration: 40, price: 30, icon: "🔥", popular: false },
      { id: "s5", name: "Kids Haircut",         description: "Gentle cut for children under 12",              duration: 25, price: 18, icon: "⭐", popular: false },
      { id: "s6", name: "Hair Color",           description: "Professional color treatment & styling",         duration: 90, price: 65, icon: "🎨", popular: false },
    ],
    staff: [
      { id: "b1", name: "Marcus Cole",  specialty: "Classic Cuts & Fades",      bio: "10 years experience. Known for precision fades.", rating: 4.9, reviews: 210, initials: "MC", color: "from-emerald-500 to-green-700" },
      { id: "b2", name: "Diego Rivera", specialty: "Beard Sculpting & Grooming", bio: "Beard specialist with a passion for sharp lines.", rating: 4.8, reviews: 174, initials: "DR", color: "from-teal-500 to-emerald-700"  },
      { id: "b3", name: "Priya Shah",   specialty: "Color, Styling & Texture",   bio: "Creative colorist. Expert in modern cuts.",        rating: 4.9, reviews: 128, initials: "PS", color: "from-green-600 to-teal-800"   },
    ],
    testimonials: [
      { id: 1, name: "Alex Turner",  initials: "AT", rating: 5, text: "Best barbershop experience I've had. Online booking saved so much time!", service: "Classic Haircut" },
      { id: 2, name: "James Okafor", initials: "JO", rating: 5, text: "Marcus is a wizard with fades. Booked in 30 seconds, left looking fresh.", service: "Hair + Beard Combo" },
      { id: 3, name: "Sam Patel",    initials: "SP", rating: 5, text: "Priya did an incredible job with my color. Super easy to book!",           service: "Hair Color" },
    ],
  },

  // ── Add more clients below ──────────────────────────────────────────────────
  "marcus-barbershop": {
    id:       "marcus-barbershop",
    name:     "Marcus & Co.",
    tagline:  "Where Style Meets Craft",
    timezone: "America/Chicago",
    address:  "88 Elm Street, Midtown",
    phone:    "+1 (555) 987-6543",
    email:    "book@marcusandco.com",
    hours:    "Tue–Sun 10 AM – 8 PM",
    rating:   4.8,
    reviews:  320,
    services: [
      { id: "s1", name: "Signature Fade",  description: "Marcus's signature fade cut",    duration: 40, price: 35, icon: "✂️", popular: true  },
      { id: "s2", name: "Shape Up",        description: "Clean edge and line up",          duration: 20, price: 20, icon: "📐", popular: false },
      { id: "s3", name: "Full Groom",      description: "Cut, shave, and hot towel",       duration: 60, price: 55, icon: "💈", popular: false },
    ],
    staff: [
      { id: "b1", name: "Marcus Williams", specialty: "Fades & Shape Ups", bio: "15 years in the game. Fades are his specialty.", rating: 5.0, reviews: 320, initials: "MW", color: "from-emerald-500 to-green-700" },
    ],
    testimonials: [
      { id: 1, name: "Chris D.", initials: "CD", rating: 5, text: "Marcus is the best barber I've ever had. Period.", service: "Signature Fade" },
    ],
  },
};

const tenantId = process.env.REACT_APP_TENANT_ID || "bookyara-demo";

export const TENANT = TENANTS[tenantId] || TENANTS["bookyara-demo"];
export const TIME_SLOTS = [
  "9:00 AM","9:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM",
  "12:00 PM","12:30 PM","1:00 PM","1:30 PM","2:00 PM","2:30 PM",
  "3:00 PM","3:30 PM","4:00 PM","4:30 PM","5:00 PM","5:30 PM","6:00 PM",
];
// Simulate booked slots — replace with Firestore query in production
export const BOOKED_SLOTS = ["10:00 AM", "2:00 PM", "4:30 PM"];
